<form
  autocomplete="off"
  fxLayout="column"
  fxLayout.lt-sm="column"
  fxLayoutAlign="start start"
  fxLayoutGap="10px"
  [formGroup]="formAddUser"
>
  <mat-form-field appearance="outline" fxFlex="40" color="primary" >
    <mat-label>Nome de usuário:</mat-label>
    <input
      matInput
      placeholder="Nome Usuário"
      autocomplete="off"
      formControlName="name"
    >
  </mat-form-field>

  <mat-form-field appearance="outline" fxFlex="50" color="primary" >
    <mat-label>Email:</mat-label>
    <input
      matInput
      formControlName="search"
      placeholder="Email de Contato"
      autocomplete="off"
      formControlName="email"
    >
  </mat-form-field>

  <mat-form-field appearance="outline"fxFlex="50" color="primary" >
    <mat-label>Celular:</mat-label>
    <input
      matInput
      mask="(00)00000-0000"
      placeholder="Numero de Celular"
      autocomplete="off"
      formControlName="mobile"
    >
  </mat-form-field>
</form>
